import { PureComponent } from 'react'
import styled from 'glamorous'
import map from 'lodash/map'

import { $ } from 'utils'
import { InertialScrolling, Loader, ImagePure } from 'components'


const Container = styled.div({
  flex: 1,
  height: '100%',
  borderRight: 'var(--border)',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  padding: '30px 0px 0 30px'
})

const InnerContainer = styled.div({
  width: '340px',
})

const Header = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 15,
})

const HeaderName = styled.div({
  fontWeight: 'bold',
  fontSize: 19,
})

const HeaderId = styled.div({
  fontSize: 15,
  color: 'var(--lightGrey)'
})

const HeaderIdName = styled.span({
  fontWeight: 'bold',
  fontSize: 15,
  marginRight: 5,
  textTransform: 'uppercase',
  color: 'var(--black)'
})

const Avatar = styled.div({
  position: 'relative',
  marginBottom: 10,
})

const PhotoContainer = styled.div({
  flex: 1,
  overflow: 'hidden',
  height: 50,
})

const PhotoInnerContainer = styled.div({
  display: 'flex',
  height: '100%',
  overflow: 'auto',
  cursor: 'pointer'
})

const MinPhoto = styled.div({
  marginRight: 5,
  '& img': {
    userDrag: 'none',
    WebkitUserDrag: 'none'
  }
})


export default class VerificatedPerson extends PureComponent {

  render = () => {
    const { loading, verify, error } = this.props
    if (loading) return $(Container, $(Loader))

    return (
      $(Container,
        error
          ? null
          : $(InnerContainer,
              $(Header,
                $(HeaderName, (verify[0].similarity * 100).toFixed(2) + '%'),
                $(HeaderId,
                  $(HeaderIdName, 'Id:'),
                  verify[0].person.uuid
                )
              ),
              $(Avatar,
                $(ImagePure, {
                  src: verify[0].person.portrait,
                  width: 286,
                  height: 370
                })
              ),
              $(PhotoContainer,
                $(PhotoInnerContainer,
                  $(InertialScrolling,
                    map(verify[0].person.descriptors, (val, key) =>
                      $(MinPhoto, { key },
                        $(ImagePure, {
                          src: val.portrait,
                          width: 38,
                          height: 50
                        })
                      )
                    )
                  ),
                ),
              ),
            )
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/panels/VerificationResults/VerificatedPerson.js